// Measures how noisy a video is: looks at a few frames spread through it (a crop of each, at full size: shrinking a picture would hide its grain).
import { estimateSigma, lumaOf, medianOf } from "./noise";

const seekTo = (video, t) => new Promise((resolve) => {
  const done = () => { video.removeEventListener("seeked", done); resolve(); };
  video.addEventListener("seeked", done);
  video.currentTime = t;
  setTimeout(done, 1500);
});

// Resolves with the noise as a deviation in brightness levels (0..255), or 0 when it could not be measured. The video is put back where it was.
export async function measureNoise(video, { frames = 5, crop = [768, 432] } = {}) {
  const w = video.videoWidth;
  const h = video.videoHeight;
  if (!w || !h) return 0;
  const cw = Math.min(w, crop[0]);
  const ch = Math.min(h, crop[1]);
  const canvas = document.createElement("canvas");
  canvas.width = cw;
  canvas.height = ch;
  const ctx = canvas.getContext("2d", { willReadFrequently: true });
  const was = video.currentTime;
  const wasPaused = video.paused;
  const length = isFinite(video.duration) && video.duration > 0 ? video.duration : 0;
  const times = length > 1 ? Array.from({ length: frames }, (_, i) => length * (0.1 + (0.8 * i) / Math.max(1, frames - 1))) : [0];
  const found = [];
  try {
    video.pause();
    for (const t of times) {
      await seekTo(video, t);
      ctx.drawImage(video, Math.floor((w - cw) / 2), Math.floor((h - ch) / 2), cw, ch, 0, 0, cw, ch);
      found.push(estimateSigma(lumaOf(ctx.getImageData(0, 0, cw, ch).data), cw, ch));
    }
  } catch {
    return 0;
  } finally {
    await seekTo(video, was);
    if (!wasPaused) video.play().catch(() => {});
  }
  return medianOf(found);
}
